module.exports = __webpack_public_path__ + "img/hr-V-R-1-unload-connect.c56307ab.png";